import { isAllUpSelection, isNoveltyBetType } from '@mobi/betslip/helpers/typeGuards'
import type {
  BettingType,
  FobPropositionSelection,
  RacingBetType,
  Selection,
  ToteSelection,
} from '@mobi/betslip/types'

export function getMarketTitle(selection: Selection) {
  if ((selection as ToteSelection).betType) {
    return (selection as ToteSelection).betType
  }
  if ((selection as FobPropositionSelection).marketCode) {
    return (selection as FobPropositionSelection).marketName
  }
  const defaultVal: Extract<RacingBetType, 'Win & Place'> = 'Win & Place'
  return defaultVal
}

export function getFixedOrToteDisplay(selection: Selection, bettingType: BettingType) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if (isNoveltyBetType((selection as any).betType)) {
    return ''
  }
  if (bettingType === 'fixed-odds-racing' && !(selection as FobPropositionSelection).marketCode) {
    return 'Fixed'
  }
  if (bettingType === 'tote-racing') {
    return 'Tote'
  }
  return ''
}

export function getNumberOfAllUpCombinationsSelected(selection: Selection | null): number {
  if (!isAllUpSelection(selection)) return 1
  return selection.formulas
    .filter(f => f.isSelected)
    .reduce((accumulator, currentValue) => accumulator + currentValue.numberOfCombinations, 0)
}
